import { useEffect } from 'react';
import { shallowEqual } from 'react-redux';

import { useSelector } from '../../../../selectors/useSelector';

import { SAVE_TO_PARENT_KEY, UPDATE_CURRENT_PROPERTY_KEY } from '../../../../utils/postingUtils';

// import TextFormField from 'srcLegacy/shared/components/WizardModularListing/FormFields/TextFormField';
import TextAreaFormField from '../../../../components/WizardModularListing/FormFields/TextAreaFormField';
import { logError } from '@zg-rentals/log-error';

const RoomUtilitiesAmountFormField = () => {
  const {
    listingAlias,
    propertyTypeCode,
    listingTypeCode,
    feedId,
    floorplans: [
      { floorPlanId, roomForRent: { monthlyUtilitiesShareDescription } = { monthlyUtilitiesShareDescription: '' } } = {
        floorPlanId: '',
        roomForRent: undefined,
      },
    ] = [],
  } = useSelector(
    (state) => ({
      listingAlias: state?.properties?.currentProperty?.listingAlias,
      propertyTypeCode: state?.properties?.currentProperty?.propertyTypeCode,
      listingTypeCode: state?.properties?.currentProperty?.listingTypeCode,
      feedId: state?.properties?.currentProperty?.feedId,
      floorplans: state?.properties?.currentProperty?.floorplans,
    }),
    shallowEqual,
  );

  useEffect(() => {
    if (!floorPlanId && listingAlias) {
      logError({
        error: new Error('ERROR@ MISSING — RoomUtilitiesAmount::floor plans?.[0]?.floorPlanId'),
        errorType: 'FloorPlanError',
        context: {
          listingAlias,
          propertyTypeCode,
          listingTypeCode,
          feedId,
        },
      });
    }
  }, [floorPlanId, listingAlias]);

  return (
    <TextAreaFormField
      dataTestId="RoomUtilitiesAmount"
      inputName="monthlyUtilitiesShareDescription"
      label="Monthly utilities"
      placeholder="Example: 1/3 of utility costs"
      initialValue={monthlyUtilitiesShareDescription}
      floorPlanId={floorPlanId}
      required={false}
      saveToParentKey={SAVE_TO_PARENT_KEY.FLOOR_PLANS_ROOM_FOR_RENT}
      includeDescriptionStrength={false}
      updateCurrentPropertyKey={UPDATE_CURRENT_PROPERTY_KEY.FLOOR_PLANS_ROOM_FOR_RENT}
    />
  );
};

export default RoomUtilitiesAmountFormField;
